export default {
	data() {
		return {
			title: 'GiveMeHive!',
			app_color: '#FFC107',
			logo: 'img/pittogramma_gmh.svg',
			headerColor: 'primary',
		}
	},

	methods: {
		setCustomAppData() {
			let appColor = this.$store.getters.getSetting('app_color')
			let appName = this.$store.getters.getSetting('app_name')
			let appLogo = this.$store.getters.getSetting('app_logo')
			let defaultData = this.$options.data.apply(this)

			if(appColor) {
				localStorage.setItem('app_color', appColor)
				this.app_color = this.$vuetify.theme.themes.light.primary = this.$vuetify.theme.themes.dark.primary = appColor
			} else {
				this.app_color = this.$vuetify.theme.themes.light.primary = this.$vuetify.theme.themes.dark.primary = defaultData.app_color
				localStorage.removeItem('app_color')
			}

			// Aggiorna il colore della StatusBar usando Capacitor
			this.updateStatusBarColor(this.$vuetify.theme.themes.light.primary)

			if(appName) {
				localStorage.setItem('app_name', appName)
				this.title = appName
			} else {
				localStorage.removeItem('app_name')
				this.title = defaultData.title
			}

			if(appLogo) {
				localStorage.setItem('app_logo', appLogo)
				this.logo = appLogo
			} else {
				localStorage.removeItem('app_logo')
				this.logo = defaultData.logo
			}

			this.setLogo()
		},

		/**
		 * Aggiorna il colore della StatusBar usando Capacitor
		 * @param {string} hexColor - Colore esadecimale (es: #FFC107)
		 */
		async updateStatusBarColor(hexColor) {
			if (this.$capacitor && this.$capacitor.isNative) {
				try {
					await this.$capacitor.setStatusBarColor(hexColor)
					// Imposta lo stile in base alla luminosità del colore
					const isDark = this.isColorDark(hexColor)
					await this.$capacitor.setStatusBarStyle(isDark ? 'light' : 'dark')
				} catch (error) {
					console.warn('Errore aggiornamento StatusBar:', error)
				}
			}
		},

		/**
		 * Verifica se un colore esadecimale è scuro
		 * @param {string} hexColor - Colore esadecimale
		 * @returns {boolean} true se il colore è scuro
		 */
		isColorDark(hexColor) {
			// Rimuovi il # se presente
			const hex = hexColor.replace('#', '')
			// Converti in RGB
			const r = parseInt(hex.substr(0, 2), 16)
			const g = parseInt(hex.substr(2, 2), 16)
			const b = parseInt(hex.substr(4, 2), 16)
			// Calcola la luminosità (formula YIQ)
			const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000
			return yiq < 128
		},

		/**
		 * Converte app_color (hex) in una stringa rgba con l'opacità data.
		 * Fallback al giallo amber (#FFC107) se il colore non è parsabile.
		 * @param {number} opacity - opacità da 0 a 1
		 * @returns {string} es: rgba(255, 193, 7, 0.35)
		 */
		appColorToRgba(opacity) {
			const hex = (this.app_color || '#FFC107').replace('#', '')
			const r = parseInt(hex.substr(0, 2), 16)
			const g = parseInt(hex.substr(2, 2), 16)
			const b = parseInt(hex.substr(4, 2), 16)
			const valid = !isNaN(r) && !isNaN(g) && !isNaN(b)
			const rgb = valid ? `${r}, ${g}, ${b}` : '255, 193, 7'
			return `rgba(${rgb}, ${opacity})`
		},

		getCustomAppData() {
			if(localStorage.getItem('app_color')) {
				this.app_color = localStorage.getItem('app_color')
				this.$vuetify.theme.themes.light.primary = this.$vuetify.theme.themes.dark.primary = this.app_color
				// Aggiorna anche la StatusBar con il colore salvato
				this.updateStatusBarColor(this.app_color)
			}
			if(localStorage.getItem('app_name')) {
				this.title = localStorage.getItem('app_name')
			}
			if(localStorage.getItem('app_logo')) {
				this.logo = localStorage.getItem('app_logo')
			}
			if(localStorage.getItem('colorMode') == null){
				this.$vuetify.theme.dark = false
			} else {
				this.$vuetify.theme.dark = JSON.parse(localStorage.getItem('colorMode'))
			}
			this.setLogo()
		},

		setLogo() {
			let setting_logo = this.$store.getters.getSetting('app_logo') || localStorage.getItem('app_logo')
			if(setting_logo) {
				this.logo = setting_logo
			} else if(this.$eventBusUtility.currentColorMode == 'dark') {
				//this.logo = 'img/pittogramma_yello_bianco.svg'
				this.logo = 'img/pittogramma_gmh_bianco.svg'
			} else {
				this.logo = 'img/pittogramma_gmh.svg'
			}
		}
	},

	computed: {
		// CSS custom properties per il bordo dei v-list-group nel menu laterale (segue app_color)
		moduleGroupBorderVars() {
			return {
				'--module-group-border': this.appColorToRgba(0.35),
				'--module-group-border-dark': this.appColorToRgba(0.5)
			}
		}
	}
}